import vm from '@/main'

const i18n = param => vm.$t(`_staff.labelExpensePercentage.${param}`)
const typeDictData = [
  {
    label: 'EPC Projects',
    dictCode: 'project',
    value: '3',
  },
  {
    label: 'PMC Projects',
    dictCode: 'developerproject',
    dictQuery: { projectattr: '1' },
    value: '1',
  },
  {
    label: 'PDC Projects',
    dictCode: 'developerproject',
    dictQuery: { projectattr: '2' },
    value: '2',
  },
  {
    label: 'Allocation department',
    dictCode: 'dept',
    value: '4',
  },
]
export default (form = {}, max = 1) => {
  let numberMax = max
  if (form.id && form.expense) {
    numberMax += Number(form.expense) > 1 ? 1 : Number(form.expense)
  }
  const typeDictCodeT = typeDictData.find(o => o.value === form.type) || {}
  const column = [
    {
      label: i18n('type'),
      field: 'type',
      dictField: 'typeName',
      formOption: {
        type: 'select',
        dictData: typeDictData,
        rules: 'required',
      },
    },
    {
      label: i18n('projectOrDept'),
      field: 'projectOrDeptId',
      dictField: 'projectOrDeptName',
      formOption: {
        type: 'select',
        hide: !typeDictCodeT.dictCode,
        dictCode: typeDictCodeT.dictCode,
        updateNow: true,
        dictQuery: typeDictCodeT.dictQuery,
      },
    },
    {
      label: i18n('post'),
      field: 'positionId',
      hide: true,
      formOption: {
        type: 'select',
        dictCode: 'post',
        hide: typeDictCodeT.value !== '4',
        updateNow: true,
        dictQuery: {
          category: 1,
          deptId: form.projectOrDeptId,
        },
        small: vm.$t('_components.placeholder.firstInput') + i18n('dept'),
      },
    },
    {
      label: i18n('startDate'),
      field: 'startDate',
      formOption: {
        type: 'date',
      },
    },
    {
      label: i18n('endDate'),
      field: 'endDate',
      formOption: {
        type: 'date',
      },
    },
    {
      label: i18n('expense'),
      field: 'expense',
      formOption: {
        type: 'number',
        numberMin: 0,
        numberMax,
      },
    },
  ]
  return column
}
